import { render, staticRenderFns } from "./TransactionCreateUpdateForm.vue?vue&type=template&id=761bac74"
import script from "./TransactionCreateUpdateForm.vue?vue&type=script&lang=js"
export * from "./TransactionCreateUpdateForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports